
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { UserComponent } from './user.component';

import { FormsModule } from '@angular/forms';
import { NewUserComponent } from "./newUser.component";
import { ReactiveFormsModule} from '@angular/forms'
import {RouterModule} from "@angular/router";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from "@angular/material/button";
import {UserMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {TranslateModule} from "@ngx-translate/core";
import {UserDataResolve} from "./userData.resolve";
import {DeleteUserDialogComponent} from "./dialog/deleteUserDialog.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import {DeleteCardDialogComponent} from "../card/dialog/deleteCardDialog.component";
import {SecurityModule} from "../security/security.module";
import {ChangeNumberDialogComponent} from "../card/dialog/changeNumberDialog.component";
import {TrainerComponent} from "./trainer.component";
import {TrainerSidebarComponent} from "./sidebars/trainer/trainer-sidebar.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {UserIdleComponent} from "./user-idle/user-idle.component";

@NgModule({
    declarations: [
        UserComponent,
        NewUserComponent,
        UserMainSidebarComponent,
        TrainerSidebarComponent,
        DeleteUserDialogComponent,
        DeleteCardDialogComponent,
        ChangeNumberDialogComponent,
        TrainerComponent,
        UserIdleComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        FlexLayoutModule,
        MatSelectModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        TranslateModule,
        MatToolbarModule,
        MatDialogModule,
        SecurityModule,
        MatCheckboxModule,
    ],
    providers: [UserDataResolve],
    exports: [
        UserIdleComponent
    ],
    bootstrap: [
        UserComponent,
        NewUserComponent,
        DeleteUserDialogComponent,
        DeleteCardDialogComponent,
        ChangeNumberDialogComponent,
        TrainerComponent,
        UserIdleComponent,
    ]
})
export class UserModule { }
